// Manquants: port de backend/app/core/shortages.py et backend/app/core/volume_variance.py.
const num = (valeur) => {
  const n = Number.parseFloat(valeur);
  return Number.isFinite(n) ? n : 0;
};

export function metriquesDeManquant({ loaded, delivered, returned = null, remaining = null, final = false, tolerance = 100, tolerance_percent: tolerancePourcent = 0 }) {
  if (loaded === null || loaded === undefined || delivered === null || delivered === undefined) {
    return { classification: 'UNKNOWN', shortage_liters: null, surplus_liters: null, delta_liters: null };
  }
  const base = num(loaded);
  const reel = num(delivered) + num(returned) + num(remaining);
  const ecart = reel - base;
  const manquant = Math.max(-ecart, 0);
  const excedent = Math.max(ecart, 0);
  const pourcentage = base ? (manquant / base) * 100 : 0;
  const dansLaTolerance = manquant <= num(tolerance) || (num(tolerancePourcent) > 0 && pourcentage <= num(tolerancePourcent));
  let classification;
  if (!final) classification = 'IN_PROGRESS';
  else if (excedent) classification = 'SURPLUS';
  else classification = dansLaTolerance ? 'WITHIN_TOLERANCE' : 'OUTSIDE_TOLERANCE';
  return {
    classification,
    shortage_liters: final ? manquant : null,
    surplus_liters: final ? excedent : null,
    delta_liters: final ? ecart : null,
  };
}

const arrondi = (valeur, decimales) => {
  const f = 10 ** decimales;
  return Math.round((valeur + Number.EPSILON) * f) / f;
};

export function jugerEcart({ expected, actual, tolerance_liters: tolLitres = 100, tolerance_percent: tolPourcent = 0, rule_id: regle = 'default' }) {
  const attendu = num(expected);
  const constate = num(actual);
  const ecart = constate - attendu;
  const ecartPourcent = attendu ? (ecart / attendu) * 100 : 0;
  const litresDepasses = tolLitres > 0 ? Math.abs(ecart) > tolLitres : false;
  const pourcentDepasse = tolPourcent > 0 ? Math.abs(ecartPourcent) > tolPourcent : false;
  let gravite;
  if (tolLitres <= 0 && tolPourcent <= 0) gravite = Math.abs(ecart) > 0 ? 'breach' : 'ok';
  else if ((litresDepasses && (pourcentDepasse || tolPourcent <= 0)) || (pourcentDepasse && tolLitres <= 0)) gravite = 'breach';
  else if (litresDepasses || pourcentDepasse) gravite = 'watch';
  else gravite = 'ok';
  let direction = 'CONFORME';
  if (ecart < 0) direction = 'MANQUANT';
  else if (ecart > 0) direction = 'EXCEDENT';
  return {
    expected: attendu,
    actual: constate,
    delta_liters: arrondi(ecart, 2),
    delta_percent: arrondi(ecartPourcent, 4),
    severity: gravite,
    direction,
    threshold_liters: tolLitres,
    threshold_percent: tolPourcent,
    rule_id: regle,
  };
}
